import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';

import { PichBaseComponent } from '../pichincha-base.component';

import { CommonDataService } from '../../../shared/services/common-data.service';
import { PichCommonHttpService } from '../../services/pichincha-common-http.service';
import { GtmService } from './../../../shared/services/gtm/gtm.service';

import { ACTION, CURRENT_POSITION, PATHS } from './../../../shared/constants';
import {
  PersonalBeneficModel,
  PersonalInfoModel
} from './../../model/params.model';
import { ParamsModel } from './../../../shared/model/api/params.model';

import { MiddlewareService } from '../../../shared/services/middleware.service';
import { ConfirmationService } from '../../../vass-core/components/modal/confirmation.service';
import { PersonalDataService } from '../../services/personal.data.service';
import { ToolboxService } from '../../../shared/services/toolbox/toolbox.service';
import { OnboardingService } from '../../services/onboarding/onboarding.service';

/**
 * Pantalla de datos personales paso 1 del flujo de onboarding.
 * Gestiona datos básicos del cliente, beneficiarios locales
 * y la navegación hacia el siguiente paso.
 */
@Component({
  selector: 'app-pich-personal-data-1',
  templateUrl: './pich-personal-data-1.component.html',
  styleUrls: ['./pich-personal-data-1.component.scss'],
  providers: [ToolboxService]
})
export class PichPersonalData1Component
  extends PichBaseComponent
  implements OnInit, OnDestroy {

  private nextStage = PATHS.personalData2;
  public prevStage = PATHS.identityManualConfirm;
  personalData: PersonalInfoModel;
  isSecondHolder = false;
  isMultTitulares = false;

  formData: FormGroup;
  formDataBenefic: FormGroup;

  currentPosition: any;
  currentPositionList: ParamsModel[] = [];

  HTML_VALIDATORS = {
    minLength: 2,
    maxLength: {
      name: 50,
      firstLastName: 50,
      secondLastName: 50,
      fullAddress: 200,
      addressBen: 200,
      cityOfResidence: 80
    }
  };

  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth(),
    new Date().getDate()
  );
  minDate = new Date(`01/01/${new Date().getFullYear() - 100}`);
  selectedValue: string;
  benefic: boolean = false;
  createBeneficiaryTable: PersonalBeneficModel[] = [];
  countries: any[] = [];
  requiresBen: boolean = false;
  checkRadio: boolean = false;
  lookBenefic: boolean;
  beneficiarios: FormGroup[] = [];
  agreeBenefic: PersonalBeneficModel[] = [];
  mensaje: string =
    'Puede nombrar una o varias personas como beneficiarios. En caso de fallecer todos los titulares, los fondos en esta cuenta personal serán pagados a los beneficiarios designados en esta sección';
  dataRequiresBen: boolean;
  country: string;

  constructor(
    private routerC: Router,
    private pichCService: PichCommonHttpService,
    private formbuilder: FormBuilder,
    public commonDataService: CommonDataService,
    private gtmService: GtmService,
    private middlewareService: MiddlewareService,
    protected confirmationService: ConfirmationService,
    private personalDataService: PersonalDataService,
    private readonly toolboxService: ToolboxService,
    private readonly onboardingService: OnboardingService
  ) {
    super(routerC, pichCService, confirmationService);
  }

  ngOnInit() {
    this.currentPosition = CURRENT_POSITION;
    console.log(this.currentPosition);
    this.loadData();
    this.createForm();
    this.loadDropDownData();
    this.onboardingService.getCurrentPositions().subscribe((data) => {
      this.currentPositionList = data;
    });
    this.canNavigateToBack(false);
    this.isSecondHolder = this.commonDataService.isSecondHolder;
    this.isMultTitulares = this.commonDataService.isMultTitulares;
  }

  loadDropDownData() {
    this.toolboxService.getCountries().subscribe(
      (data) => {
        this.countries = data;
      },
      (error) => {
        this.setErrorMessages(error.responseCode);
      }
    );
  }

  ngOnDestroy() {
    this.canNavigateToBack(true);
  }

  private createForm() {
    this.formData = this.formbuilder.group({
      name: [
        '',
        [
          Validators.required,
          Validators.minLength(this.HTML_VALIDATORS.minLength),
          Validators.maxLength(this.HTML_VALIDATORS.maxLength.name)
        ]
      ],
      firstLastName: [
        '',
        [
          Validators.required,
          Validators.minLength(this.HTML_VALIDATORS.minLength),
          Validators.maxLength(this.HTML_VALIDATORS.maxLength.firstLastName)
        ]
      ],
      secondLastName: [
        '',
        [
          Validators.minLength(this.HTML_VALIDATORS.minLength),
          Validators.maxLength(this.HTML_VALIDATORS.maxLength.secondLastName)
        ]
      ],
      birthDate: ['', [Validators.required, this.dateValidator]],
      cityOfResidence: [
        '',
        [
          Validators.required,
          Validators.minLength(this.HTML_VALIDATORS.minLength),
          Validators.maxLength(this.HTML_VALIDATORS.maxLength.cityOfResidence)
        ]
      ],
      fullAddress: [
        '',
        [
          Validators.required,
          Validators.minLength(this.HTML_VALIDATORS.minLength),
          Validators.maxLength(this.HTML_VALIDATORS.maxLength.fullAddress)
        ]
      ],
      requiresBen: false
    });
  }

  private createFormBenefic() {
    this.formDataBenefic = this.formbuilder.group({
      fullNameBen: ['', []],
      birthdateBen: ['', ['', [Validators.required, this.dateValidator]]],
      addressBen: [
        '',
        [
          Validators.required,
          Validators.minLength(this.HTML_VALIDATORS.minLength),
          Validators.maxLength(this.HTML_VALIDATORS.maxLength.fullAddress)
        ]
      ],
      countryNationalityBen: [''],
      countryBirthBen: [''],
      phoneNumberBen: [
        '',
        [
          Validators.required,
          Validators.minLength(this.HTML_VALIDATORS.minLength)
        ]
      ],
      occupationBen: ['', ['']],
      relationshipBen: ['', Validators.required]
    });
  }

  dateValidator(control: any) {
    if (!control.value) {
      return null;
    }

    const regexDate = /^\d{4}-\d{2}-\d{2}$/;

    if (!regexDate.test(control.value)) {
      return { invalidDate: true };
    }

    const [year, month, day] = control.value.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    if (
      date.getFullYear() === year &&
      date.getMonth() + 1 === month &&
      date.getDate() === day
    ) {
      return null;
    } else {
      return { invalidDate: true };
    }
  }

  get control() {
    return this.formData.controls;
  }

  public getAction(): string {
    return ACTION.savePersonalData;
  }

  loadData() {
    this.middlewareService.getUsersLookup().subscribe((data) => {
      this.dataRequiresBen = data?.requiresBen ? true : false;
      this.country = data.sourceCountry;

      if (this.dataRequiresBen) {
        this.onClick();
        if (data?.createBeneficiaryTable) {
          let arrayBenefic = data?.createBeneficiaryTable;
          arrayBenefic.forEach((i: any) => {
            if (i.idBen) {
              this.beneficiarios.push(
                this.formbuilder.group({
                  fullNameBen: [
                    i.fullNameBen ?? '',
                    [
                      Validators.required,
                      Validators.minLength(this.HTML_VALIDATORS.minLength),
                      Validators.maxLength(this.HTML_VALIDATORS.maxLength.name)
                    ]
                  ],
                  birthdateBen: [i.birthdateBen ?? '', [Validators.required, this.dateValidator]],
                  addressBen: [
                    i.addressBen ?? '',
                    [
                      Validators.required,
                      Validators.minLength(this.HTML_VALIDATORS.minLength),
                      Validators.maxLength(this.HTML_VALIDATORS.maxLength.fullAddress)
                    ]
                  ],
                  countryNationalityBen: [i.countryNationalityBen ?? '', Validators.required],
                  countryBirthBen: [i.countryBirthBen ?? '', Validators.required],
                  phoneNumberBen: [
                    i.phoneNumberBen ?? '',
                    [
                      Validators.required,
                      Validators.minLength(this.HTML_VALIDATORS.minLength)
                    ]
                  ],
                  occupationBen: [i.occupationBen ?? '', Validators.required],
                  relationshipBen: [i.relationshipBen ?? '', Validators.required],
                  idBen: i.idBen
                })
              );
            }
          });
        }
      }

      if (data.residentialAddress && data.residentialAddress.length > 0) {
        this.formData.patchValue({
          name: data.firstName,
          firstLastName: data.lastName,
          secondLastName: data.secondLastName,
          birthDate: data.birthDate,
          cityOfResidence: data.cityOfResidence,
          fullAddress: data.residentialAddress,
          requiresBen: data?.requiresBen
        });
      }

      this.dataRequiresBen = false;

      this.personalData = data;
      this.benefic = true;
      return this.personalData;
    });
    this.pichCService.getDocumentsStatus().subscribe(
      (data) => { },
      (error) => {
        this.setErrorMessages(error.responseCode);
      }
    );
  }

  onBackStage(prevStage: string) {
    this.routerC.navigate(['onboarding', prevStage]);
  }

  private getPersonalInfo(): PersonalInfoModel {
    return {
      firstName: this.formData.value.name,
      middleName: ' ',
      lastName: this.formData.value.firstLastName,
      secondLastName: this.formData.value.secondLastName,
      birthDate: this.formData.value.birthDate,
      cityOfResidence: this.formData.value.cityOfResidence,
      countryOfResidence: this.country,
      residentialAddress: this.formData.value.fullAddress,
      countryOfBirth: this.personalData.countryOfBirth,
      nationality: this.personalData.nationality,
      passportNumber: this.personalData.passportNumber,
      expiryDate: this.personalData.expiryDate,
      countryOfExpedition: this.personalData.countryOfExpedition,
      documentType: 'PASAPORTE',
      documentNumber: this.personalData.documentNumber,
      taxDocumentNumber: this.personalData.taxDocumentNumber,
      step: '1',
      createBeneficiaryTable: this.createBeneficiaryTable,
      requiresBen: this.formData.value.requiresBen
    };
  }

  private getPersonalInfo1(): PersonalInfoModel {
    return {
      firstName: this.formData.value.name,
      middleName: ' ',
      lastName: this.formData.value.firstLastName,
      secondLastName: this.formData.value.secondLastName,
      birthDate: this.formData.value.birthDate,
      cityOfResidence: this.formData.value.cityOfResidence,
      countryOfResidence: this.country,
      residentialAddress: this.formData.value.fullAddress,
      countryOfBirth: this.personalData.countryOfBirth,
      nationality: this.personalData.nationality,
      passportNumber: this.personalData.passportNumber,
      expiryDate: this.personalData.expiryDate,
      countryOfExpedition: this.personalData.countryOfExpedition,
      documentType: 'PASAPORTE',
      documentNumber: this.personalData.documentNumber,
      taxDocumentNumber: this.personalData.taxDocumentNumber,
      step: '1',
      requiresBen: this.formData.value.requiresBen
    };
  }

  onNext() {
    if (this.formData.valid) {
      if (!this.requiresBen) {
        this.middlewareService
          .setPersonalInfo(this.getPersonalInfo1())
          .subscribe(
            (data) => {
              this.personalDataService.setPersonalData(this.getPersonalInfo1());
              this.onNextStage(this.nextStage);
            },
            (error) => {
              this.setErrorMessages(error.responseCode);
            }
          );
      } else {
        if (this.beneficiarios.length > 0 && !this.validateBeneficiary()) {
          return;
        }
        this.assignedBeneficiary();

        this.middlewareService
          .setPersonalInfo(this.getPersonalInfo())
          .subscribe(
            (data) => {
              this.personalDataService.setPersonalData(this.getPersonalInfo());
              this.onNextStage(this.nextStage);
            },
            (error) => {
              this.setErrorMessages(error.responseCode);
            }
          );
      }
    } else {
      this.formData.markAllAsTouched();
    }
  }

  onClick() {
    if (this.dataRequiresBen) {
      this.lookBenefic = true;
      this.requiresBen = true;
    } else {
      this.checkRadio = this.formData.value.requiresBen;
      this.requiresBen = this.formData.value.requiresBen;
      if (this.checkRadio === true) {
        this.lookBenefic = true;
        if (this.beneficiarios.length == 0) {
          this.agregarBeneficiarios();
        }
      } else {
        this.lookBenefic = false;
        this.beneficiarios = [];
      }
    }
  }

  validateBeneficiary() {
    this.formData.valid;
    let isValidate = true;
    this.beneficiarios.forEach((i: any) => {
      if (!i.valid) {
        isValidate = false;
        i.markAllAsTouched();
      }
    });
    return isValidate;
  }

  assignedBeneficiary() {
    this.beneficiarios.forEach((i: any) => {
      this.createBeneficiaryTable.push(i.value);
    });
  }

  agregarBeneficiarios() {
    this.beneficiarios.push(
      this.formbuilder.group({
        fullNameBen: [
          '',
          [
            Validators.required,
            Validators.minLength(this.HTML_VALIDATORS.minLength),
            Validators.maxLength(this.HTML_VALIDATORS.maxLength.name)
          ]
        ],
        birthdateBen: ['', [Validators.required, this.dateValidator]],
        addressBen: [
          '',
          [
            Validators.required,
            Validators.minLength(this.HTML_VALIDATORS.minLength),
            Validators.maxLength(this.HTML_VALIDATORS.maxLength.fullAddress)
          ]
        ],
        countryNationalityBen: ['', Validators.required],
        countryBirthBen: ['', Validators.required],
        phoneNumberBen: [
          '',
          [
            Validators.required,
            Validators.minLength(this.HTML_VALIDATORS.minLength)
          ]
        ],
        occupationBen: ['', Validators.required],
        relationshipBen: ['', Validators.required]
      })
    );
  }
}
